import decode from 'jwt-decode';
import { DEV_PORTAL_APP_ID } from '../app-config';

const TOKEN_NAME = 'token';

export default class AuthService {
  static login(token: string) {
    // Call the show method to display the widget.
    AuthService.setToken(token);
  }

  static loggedIn(): boolean {
    // Checks if there is a saved token and it's still valid
    const idToken = AuthService.getToken();

    if (!idToken) {
      return false;
    }

    return !AuthService.isTokenExpired(idToken);
  }

  static setToken(token: string) {
    // Saves user token to localStorage
    try {
      decode(token);
      localStorage.setItem(TOKEN_NAME, token);
    } catch (e) {
      console.log('token validation failed', e);
    }
  }

  static getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem(TOKEN_NAME);
  }

  static getHatname(encToken?: string): string | null {
    // Retrieves the user token from localStorage
    const encodedToken = encToken || AuthService.getToken();
    if (encodedToken) {
      const token = decode(encodedToken);
      // @ts-ignore
      return token.iss;
    }
    return null;
  }

  static logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem(TOKEN_NAME);
  }

  static getTokenExpirationDate(encodedToken: string): Date | null {
    try {
      const token = decode(encodedToken);
      // @ts-ignore
      const { exp } = token;
      // @ts-ignore
      const { application } = token;
      if (!exp) {
        return null;
      }

      if (application !== DEV_PORTAL_APP_ID) {
        return null;
      }

      const date = new Date(0);
      date.setUTCSeconds(exp);

      return date;
    } catch (e) {
      return null;
    }
  }

  static isTokenExpired(token: string): boolean {
    const expirationDate = AuthService.getTokenExpirationDate(token);

    if (!expirationDate) {
      return true;
    }
    return expirationDate < new Date();
  }
}
